import React from "react";
import boostRocket from "images/boost/boost-rocket.webp";
import boostWave from "images/boost/boost-wave.webp";

const PricingContainer = ({ children = null }) => {
  return (
    <div
      className="bg-black relative w-full"
    >
      <span className="relative hidden xl:block">
        <img src={boostRocket} alt="" className="absolute" style={{ top: 92, left: 40, height: 150, width: "auto" }} />
      </span>
      {children}
      <img src={boostWave} alt="" className="w-full xl:w-1/2" />
    </div>
  );
};

export default PricingContainer;